"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANCELED = exports.defaultBridge = void 0;
exports.defaultBridge = 'https://bridge.walletconnect.org';
exports.CANCELED = Symbol('canceled');